<template>
  <div class="preview-dialog">
    <el-dialog
      :title="$t('lcd.material.previewTemplateObj.title')"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      class="lcdPreviewDialog"
    >
      <!-- {{ previewObj }} -->
      <div class="cont">
        <el-carousel :interval="5000" height="500px" width="800px">
          <el-carousel-item
            v-for="(item, index) in previewObj.templateImageUrlList"
            :key="item"
          >
            <h3 class="medium" style="color: #fff; margin-bottom: 15px">
              {{ itemDesc[index] }}
            </h3>
            <img style="border: 3px solid #000" :src="item" height="420" />
          </el-carousel-item>
        </el-carousel>
        <el-descriptions
          size="medium"
          :column="1"
          class="imgInfo"
          :title="$t('lcd.Template.Template Info')"
        >
          <el-descriptions-item :label="$t('lcd.Template.Template Name')">{{
            previewObj.templateName
          }}</el-descriptions-item>
          <el-descriptions-item :label="$t('lcd.Template.Template No')">{{
            previewObj.templateId
          }}</el-descriptions-item>
          <el-descriptions-item :label="$t('lcd.Template.Resolution')">{{
            previewObj.templateSize
          }}</el-descriptions-item>
          <el-descriptions-item :label="$t('lcd.Template.Max Number of Items')">
            <el-tag size="small" type="success">{{
              previewObj.itemQty
            }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item v-if="previewObj.labelType" :label="$t('lcd.Template.Template Label')">
            <el-tag size="small" type="success">{{
              previewObj.labelTypeDesc
            }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item :label="$t('lcd.Template.Publish Status')">
            <el-tag size="small" type="danger">{{
              previewObj.activeStateDesc
            }}</el-tag>
          </el-descriptions-item>
          <!-- <el-descriptions-item :label="$t('lcd.Template.Use Status')">
            <el-tag size="small" type="success">{{
              previewObj.usageState
            }}</el-tag>
          </el-descriptions-item> -->
          <el-descriptions-item :label="$t('lcd.Template.Create Time')">{{
            previewObj.updateTime
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "ConfirmDialog",
  data() {
    return {
      itemDesc: [
        this.$t("lcd.Template.Unbind Template"),
        this.$t('lcd.Template.One Item'),
        this.$t('lcd.Template.Two Items'),
        this.$t('lcd.Template.Three Items'),
        this.$t('lcd.Template.Four Items'),
      ],
    };
  },
  props: {
    dialogVisible: {
      type: Boolean,
      required: true,
    },
    previewObj: {
      type: Object,
      default: null,
    },
  },
  methods: {
    handleClose(val) {
      this.$emit("handleClose", val);
    },
  },
};
</script>
<style lang="scss">
.lcdPreviewDialog {
  .el-dialog__header {
    background-color: #fff !important;
  }
}
</style>
<style lang="scss" scoped>
.preview-dialog ::v-deep {
  color: #35b871;
  .el-dialog__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .el-dialog {
    height: 600px;
    border-radius: 6px;
    width: 1100px;
    margin-top: 0 !important;
    margin: 0 !important;
    background-color: rgba($color: #000000, $alpha: 0.4);
    // border: 2px solid #000000;
  }
  ::v-deep .el-dialog__body {
    padding: 0 !important;
  }
  .cont {
    width: 100%;
    text-align: center;
    height: 510px;
    padding-right: 350px;
    .imgWrap {
      width: 600px;
      height: 490px;
      position: relative;
      background-color: #f5f5f5;
      border-radius: 4px;
      float: left;
      .materialImage,
      video {
        display: block;
        margin: 0 auto;
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .imgInfo {
      position: absolute;
      right: 0;
      top: 49px;
      bottom: 0;
      padding: 30px;
      width: 350px;
      float: right;
      background-color: #fff;
    }

    .icon {
      display: flex;
      justify-content: center;
      color: #ff9600;
    }
    ::v-deep .el-icon-warning-outline {
      font-size: 46px;
    }
    .text {
      margin-top: 16px;
      display: inline-block;
      // color: #FF9600;
    }
  }
  .cancel,
  .confirm {
    cursor: pointer;
    width: 50%;
    position: absolute;
    bottom: 0;
    height: 50px;
    line-height: 50px;
    border-top: 1px solid #e6e6e6;
    vertical-align: center;
  }
  .cancel {
    border-right: 1px solid #e6e6e6;
    left: 0;
    color: #333333;
  }
  .confirm {
    right: 0;
    color: #35b871;
  }
}
</style>